import Vue from "vue";
import "normalize.css/normalize.css"; // 基础样式 CSS RESET
import "@/assets/css/common.scss"; // 公共样式
import router from "./router"; // 路由
import pinia from '@/plugins/pinia'; // 菠萝
import '@/plugins'; // 插件
import "@/assets/css/index.css"; // 放置于element之后，让tailwindcss优先级更高

import { dict } from '@/utils/dict'; // 字典
import { download } from '@/utils/request'; // 导出excel
import downloadFile from '@/utils/downloadFile'; // 下载文件
import { formatTime, formatStrip, formatMoney, formatMile } from '@/utils/format';
import App from "./App.vue";
Vue.config.productionTip = false;

// 全局方法挂载
Vue.prototype.dict = dict;
Vue.prototype.download = download; // 导出excel
Vue.prototype.downloadFile = downloadFile; // 下载文件
Vue.prototype.formatTime = formatTime;
Vue.prototype.formatStrip = formatStrip;
Vue.prototype.formatMoney = formatMoney;
Vue.prototype.formatMile = formatMile;
Vue.prototype.amapKey = '39412b907ceb505a8546ac84e1f50044';
new Vue({
  router,
  pinia,
  render: h => h(App)
}).$mount("#app");